import { serverErrorMessage } from '../utils/errors';

// WP-K (backend plan 2026-10-29-sandbox-default-tag-categories-sync): the staff endpoint (Settings › Roles,
// /tour_operator_user/) and the user save (Users › Edit, PUT /user/{id}/) refuse (403) a change without user.write,
// granting or removing a role whose access groups reach further than the caller's own, and changing one's own roles.
// The backend names the role in `detail`; without one, this text.
export const ROLE_ACCESS_REFUSED = "You can't grant or remove a role with more access than your own";

// A refused role or staff change in the backend's words: a 403's `detail`, then `message`, then the text above.
// Any other refusal as the rest of the dashboard words it.
export const roleChangeError = (res, fallback) => (res && res.statusCode === 403
    ? (res.data?.detail || res.data?.message || ROLE_ACCESS_REFUSED)
    : serverErrorMessage(res, fallback));
